import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { getMetrics } from '../../lib/admin';

export default function AdminMetrics() {
    const [m, setM] = useState(null);
    useEffect(() => { getMetrics().then(setM); }, []);
    return (
        <AdminLayout title="Métricas">
            {!m ? (
                <div className="py-20 flex justify-center"><div className="w-8 h-8 border-2 border-brand/30 border-t-brand rounded-full animate-spin" /></div>
            ) : (
                <div className="bg-white rounded-2xl border border-gray-200 p-6">
                    <pre className="text-xs font-mono text-gray-700 whitespace-pre-wrap" data-testid="metrics-raw">{JSON.stringify(m, null, 2)}</pre>
                </div>
            )}
        </AdminLayout>
    );
}
